import React from 'react';
import { ShieldAlert, CheckCircle, Handshake, MessageCircle, RefreshCw } from 'lucide-react';
const guarantees = [{
  icon: DollarSign,
  promise: 'Solo $125 para empezar',
  meaning: 'No arriesgas todo tu dinero desde el principio'
}, {
  icon: Eye,
  promise: 'Ves el resultado antes del pago final',
  meaning: 'Apruebas el diseño antes de pagar el resto'
}, {
  icon: RefreshCw,
  promise: 'Revisiones incluidas',
  meaning: 'No paramos hasta que lo ames'
}, {
  icon: Handshake,
  promise: 'Proceso transparente',
  meaning: 'Sabes exactamente qué está pasando en cada etapa'
}, {
  icon: MessageCircle,
  promise: 'Comunicación directa por WhatsApp',
  meaning: 'Respuestas rápidas, sin intermediarios'
}, {
  icon: ShieldAlert,
  promise: 'Sin mensualidades forzadas',
  meaning: 'Pagas el mantenimiento solo si lo quieres'
}];
// Need to import DollarSign and Eye since I used them in the array
import { DollarSign, Eye } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-dark relative" data-id="element-152">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <div className="text-center mb-16" data-id="element-154">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-155">
            <ShieldAlert className="w-8 h-8 text-gold" data-id="element-156" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-157">
            Cero Riesgo. 100% Satisfacción. <br className="hidden md:block" data-id="element-158" />
            <span className="text-gold" data-id="element-159">O Lo Corregimos.</span>
          </h2>
          <div className="text-lg text-gray-400 max-w-2xl mx-auto space-y-4" data-id="element-160">
            <p data-id="element-161">Sabemos que probablemente te han fallado antes.</p>
            <p data-id="element-162">
              Tal vez alguien te hizo un website que no se parecía en nada a lo
              que querías. Tal vez pagaste y nunca viste resultados.
            </p>
            <p className="text-white font-bold" data-id="element-163">Así no operamos nosotros.</p>
          </div>
        </div>

        <div className="bg-dark-100 rounded-3xl border border-white/10 p-8 md:p-12 shadow-2xl" data-id="element-164">
          <h3 className="text-2xl font-bold text-center text-white mb-10" data-id="element-165">
            Nuestra Garantía:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-166">
            {guarantees.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-167">
                <div className="bg-dark p-3 rounded-xl border border-white/5 shrink-0" data-id="element-168">
                  <item.icon className="w-6 h-6 text-gold" data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <h4 className="text-white font-bold mb-1" data-id="element-171">{item.promise}</h4>
                  <p className="text-gray-400 text-sm" data-id="element-172">{item.meaning}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-center" data-id="element-173">
            <p className="text-xl font-bold text-white" data-id="element-174">
              No das el pago final hasta que estés{' '}
              <span className="text-gold" data-id="element-175">100% satisfecho</span> con tu website.
            </p>
          </div>
        </div>
      </div>
    </section>;
}